import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

const STATUS_COLORS: Record<string, string> = {
  active: '#3fb950', Active: '#3fb950',
  trial: '#58a6ff', Trial: '#58a6ff',
  provisioning: '#d29922', Provisioning: '#d29922',
  suspended: '#f0883e', Suspended: '#f0883e',
  canceled: '#f85149', Canceled: '#f85149',
  archived: '#6e7681', Archived: '#6e7681',
  expired: '#6e7681', Expired: '#6e7681',
};

@Component({
  selector: 'app-badge',
  standalone: true,
  imports: [CommonModule],
  template: `
    <span class="badge" [style.background]="color + '18'" [style.color]="color" [class.small]="small">
      <span class="dot" [style.background]="color" [class.pulse]="isActive"></span>
      {{ label }}
    </span>
  `,
  styles: [`
    .badge {
      display: inline-flex; align-items: center; gap: 5px;
      padding: 3px 10px; border-radius: 16px;
      font-size: 12px; font-weight: 600;
    }
    .badge.small { font-size: 11px; padding: 2px 8px; }
    .dot {
      width: 6px; height: 6px; border-radius: 50%; flex-shrink: 0;
    }
    .dot.pulse { animation: pulse 2s ease-in-out infinite; }
    @keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.5; } }
  `],
})
export class BadgeComponent {
  @Input() status: string | number = '';
  @Input() small = false;

  private get text(): string {
    return this.status == null ? '' : String(this.status);
  }

  get color(): string {
    return STATUS_COLORS[this.text] || '#6e7681';
  }

  get isActive(): boolean {
    return this.text.toLowerCase() === 'active';
  }

  get label(): string {
    const t = this.text;
    return t ? t.charAt(0).toUpperCase() + t.slice(1).toLowerCase() : '';
  }
}
